import React from "react";
import { createRoot } from "react-dom/client";
import App from "./core/app";
import configureStore from "common/store";
import './i18n';
const store = configureStore({});
const root = createRoot(document.getElementById("root"));
root.render(<App store={store} />);
